import React from 'react'

import BaseTransportSummary from './BaseTransportSummary'

import type { FerryItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: FerryItem
}

function FerryItemSummary(props: Props) {
  return <BaseTransportSummary transportName="Ferry" {...props} />
}

export default FerryItemSummary
